export default __webpack_public_path__ + "static/media/wwf.81a93d93.jpg";